<header class="masthead d-flex align-items-center">
  <div class="container px-4 px-lg-5 text-center">
    <h1 class="mb-1">Ukata</h1>
    <h3 class="mb-5"><em>Training ground for the next-gen learners</em></h3>
    <a [routerLink]="'/user'" class="btn btn-primary btn-xl">Get started</a>
  </div>
</header>
